/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';
import type { PaymentSplitDtoV2 } from './PaymentSplitDtoV2';
import {
    PaymentSplitDtoV2FromJSON,
    PaymentSplitDtoV2FromJSONTyped,
    PaymentSplitDtoV2ToJSON,
    PaymentSplitDtoV2ToJSONTyped,
} from './PaymentSplitDtoV2';
import type { InitiateUnintegratedPaymentV2Request } from './InitiateUnintegratedPaymentV2Request';
import {
    InitiateUnintegratedPaymentV2RequestFromJSON,
    InitiateUnintegratedPaymentV2RequestFromJSONTyped,
    InitiateUnintegratedPaymentV2RequestToJSON,
    InitiateUnintegratedPaymentV2RequestToJSONTyped,
} from './InitiateUnintegratedPaymentV2Request';

/**
 * 
 * @export
 * @interface Cash
 */
export interface Cash extends InitiateUnintegratedPaymentV2Request {
}



/**
 * Check if a given object implements the Cash interface.
 */
export function instanceOfCash(value: object): value is Cash {
    return true;
}

export function CashFromJSON(json: any): Cash {
    return CashFromJSONTyped(json, false);
}

export function CashFromJSONTyped(json: any, ignoreDiscriminator: boolean): Cash {
    return json;
}

export function CashToJSON(json: any): Cash {
    return CashToJSONTyped(json, false);
}

export function CashToJSONTyped(value?: Cash | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

